import React from "react";
import './styles.css'

const CommonFormBorder = ({ children }) => {
    return (
        <div className='common-form-border'>{children}</div>
    )
}

export default CommonFormBorder